import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// Strip the model's inline citation markers like [[1]] or [[1,2]] / [[1-3]].
// The sources are already shown separately under the message, so the body
// stays clean — no stray brackets or numbers in the rendered text.
function stripCitationMarkers(text) {
  return String(text || '').replace(/\s?\[\[[\d\s,:-]+\]\]/g, '');
}

const components = {
  a: ({ node, children, ...props }) => (
    <a target="_blank" rel="noopener noreferrer" {...props}>
      {children}
    </a>
  ),
};

export default function Markdown({ children }) {
  return (
    <div className="md">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {stripCitationMarkers(children)}
      </ReactMarkdown>
    </div>
  );
}
